import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_InventoryBus } from "./v_InventoryBus";
import { InventoryLocationXrefBus } from "./InventoryLocationXrefBus";
import { InventoryThresholdOverrideBus } from "./InventoryThresholdOverrideBus";
import { InventorySupplierXrefBus } from "./InventorySupplierXrefBus";
import { InventoryPhotoBus } from "./InventoryPhotoBus";
import { InventoryConsumablesBus } from "./InventoryConsumablesBus";
import { InventoryConsMatchesBus } from "./InventoryConsMatchesBus";
import { InventoryThresholdOverrideBranchBus } from "./InventoryThresholdOverrideBranchBus";
import { InventoryThresholdOverrideAlternative } from "./InventoryThresholdOverrideAlternative";
import { InventoryPartNbrsBus } from "./InventoryPartNbrsBus";
import { GItem } from "./GItem";

export class InventoryBus extends BaseBus
{
    constructor(data: InventoryBus) {
        super(data);
    }

    CID(): any {
        return this.inventoryId;
    }
    calcAverage(): number {
        if (this.ratio && this.currentCost && this.ratio > 0 && this.currentCost > 0) {
            return this.currentCost / this.ratio;
        }
        return this.currentCost;
    }
    setId(id: any) {
        this.inventoryId = id;
    }
    initialize(data: InventoryBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: InventoryBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateUserId = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }

    changeInventoryItem(data: v_InventoryBus) {
        //this.number = data.number;
        //this.inventoryDesc = data.inventoryDesc;
        this.inventoryId = data.inventoryId;
  //      this.fullDescription = data.fullDescription;

        //this.quantity = 1;
        //this.qtyInStock = data..currentCost;
    }

    inventoryId: string;
    companyId: string;
    inventoryTypeId: string;
    inventoryCategoryId: string;
    inventorySubCategoryId: string;
    manufacturerId: string;
    manufacturerTypeId: string;
    isActive: boolean;
    currentCost: number;
    maxCost: number;
    lastCost: number;
    flatCost: number;
    ratio: number;
    number: string;
    model: string;
    inventoryName: string;
    inventoryDesc: string;
    notes: string;
    incomeAccountId: string;
    costAccountId: string;
    inventoryAccountId: string;
    qbid: string;
    qbeditSequenceId: string;
    internationalCost: number;
    manufacturerNumber: string;
    backupPartNumber: string;
    minThreshold: number;
    maxThreshold: number;
    wasActive: boolean;
    isCommon: boolean;
    serialNbr: string;
    warrantyEndDate: Date;
    equipmentId: string;
    needsReplacement: boolean;
    replacedInventoryId: string;
    fullDescription: string;
    nonPart: boolean;
    avgCost: number;
    defaultPrice: number;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    cycleCountClassId: string;
    inventoryLocationXrefBuss: InventoryLocationXrefBus[];
    inventoryLocationXrefBussAll: InventoryLocationXrefBus[];
    inventoryThresholdOverrides: InventoryThresholdOverrideBus[];
    inventoryAlternatives: InventoryThresholdOverrideAlternative[];
    inventoryThresholdOverrideBranchs: InventoryThresholdOverrideBranchBus[];
    inventorySupplierXrefBuss: InventorySupplierXrefBus[];
    inventoryPhotos: InventoryPhotoBus[];
    inventoryConsumablesBuss: InventoryConsumablesBus[];
    inventoryConsMatchesBuss: InventoryConsMatchesBus[];
    inventoryPartNbrs: InventoryPartNbrsBus[];

    warehouses: GItem[];
    branches: GItem[];
    photoURL: string;
    retired: string;
    installedOn: boolean;
    merged: boolean;
    onTurnQuantity: number;
    onOrderQuantity: number;
    inventoryLocationXrefBussNew: InventoryLocationXrefBus[];
    wgtAvgCost: number;

    pushWithChangeDetection<K extends keyof this>(
        key: K,
        ...items: this[K] extends Array<infer U> ? U[] : never
    ): void {
        if (Array.isArray(this[key])) {
            // @ts-ignore
            this[key] = [...(this[key] as any[]), ...items];
        } else {
            throw new Error(`${String(key)} is not an array property`);
        }
    }
}
